<div *ngIf="startDates && startDates.length > 0" class="junior-camp-dates">
  <div class="junior-camp-dates__title">Enrolment Start Dates for {{ startDates[0] | date : 'yyyy' }}</div>
  <div class="junior-camp-dates__date-list">
    <div *ngFor="let startDate of startDates" class="junior-camp-dates__date-list__label">
      {{ startDate | date : 'dd-MMMM' }}
    </div>
  </div>

  <lx-price-lists-portal-notes *ngIf="notes?.length > 0" [company]="company" [notes]="notes" class="junior-camp-dates__notes"></lx-price-lists-portal-notes>
</div>
